"use strict";

define('rs/collection.mapper',['vertebrae', 'backbone', 'underscore', './model.mapper'], function (Vertebrae, Backbone, _, ModelMapper) {
  var CollectionMapper = Vertebrae.Object.extend({
    DEBOUNCE_TIME: 100,
    initialize: function initialize(options) {
      options = _.extend({}, options);
      this.src = options.src;
      this.modelMappers = _.map(this.src.models, function (model) {
        return ModelMapper.map(model).attrs();
      });
      this.dest = options.dest || new Backbone.Collection();
      this.dest.reset([]);
      this.dest.add(_.invoke(this.modelMappers, 'model'));
      this.mappings = [];
      this.listenTo(this.src, 'add', this.add);
      this.listenTo(this.src, 'remove', this.remove);
      this.listenTo(this.src, 'reset', this.reset);
      this.listenTo(this.src, 'sort', this.sort);
    },
    duplex: function duplex(val) {
      var modelMappers = this.modelMappers;
      for (var i = 0, len = modelMappers.length, modelMapper; i < len; i++) {
        modelMapper = modelMappers[i];
        modelMapper.duplex(val);
      }
      this._duplex = !!val;
      return this;
    },
    attr: function attr(src, dest) {
      var modelMappers = this.modelMappers;
      if (!dest) {
        dest = src;
      }
      for (var i = 0, len = modelMappers.length, modelMapper; i < len; i++) {
        modelMapper = modelMappers[i];
        modelMapper.attr(src, dest);
      }
      this.mappings.push({
        src: src,
        dest: dest,
        duplex: this._duplex
      });
      return this;
    },
    add: function add(model, collection, options) {
      var index = options.index,
        modelMapper = ModelMapper.map(model);
      modelMapper.attrs(this.mappings);
      this.modelMappers.push(modelMapper);
      this.dest.add(modelMapper.model(), {
        at: index
      });
      return this;
    },
    remove: function remove(model, collection, options) {
      var index = options.index;
      modelMapper = modelMapper.at(index);
      this.modelMappers = _.without(this.modelMappers, modelMapper);
      this.dest.remove(modelMapper.model());
      modelMapper.stopListening();
      modelMapper = null;
      return this;
    },
    reset: function reset(collection, options) {
      var modelMappers = this.modelMappers;
      for (var i = 0, len = modelMappers.length, modelMapper; i < len; i++) {
        modelMapper = modelMappers[i];
        modelMapper.stopListening();
        modelMapper.model().stopListening();
      }
      this.modelMappers = [];
      return this;
    },
    sort: function sort(collection, options) {
      return this;
    },
    collection: function collection() {
      return this.dest;
    }
  }, {
    map: function map(src, dest) {
      return new this({
        src: src,
        dest: dest
      });
    }
  });
  return CollectionMapper;
});

